var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-panel',{attrs:{"width":"short","title":"Nueva tarea"},on:{"closePanel":_vm.onCloseModal}},[_c('tasks-form',{attrs:{"old":_vm.oldTask,"customer":_vm.customer}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecebe58e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/app/tasks/tasks-create-view.vue
// module id = null
// module chunks = 